import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { SoundService } from '../../service/sound.service';

@Component({
  selector: 'app-studies',
  templateUrl: './studies.component.html',
  styleUrls: ['./studies.component.scss']
})
export class StudiesComponent implements OnInit, AfterViewInit, OnDestroy {

  language: string = document.URL.split('/')[3];

  subscribtion: Subscription;
  studies: Array<any>;
  constructor(private sound: SoundService, private translate: TranslateService) { }

  ngOnInit() {
    this.subscribtion = this.translate.stream('STUDIES.TS').subscribe((res: any) => {
      this.studies = new Array<any>();
      res.forEach(item => {
        item.link = "/"+ this.language + item.link;
        this.studies.push(item);
      });
    });
  }

  ngAfterViewInit() {
  }

  ngOnDestroy(): void {
    this.subscribtion.unsubscribe();
  }

  studiesCarouselOptions = {
    items: 3,
    margin: 90,
    nav: true,
    navText: ["<div class='nav-btn prev-slide'></div>", "<div class='nav-btn next-slide'></div>"],
    dots: false,
    slideSpeed: 300,
    paginationSpeed: 400,
    loop: true,
    responsive: {
      0: {
        items: 1,
        margin: 10
      },
      576: {
        items: 1,
        margin: 10
      },
      991: {
        items: 2
      },
      1600: {
        items: 2
      }
    }
  }

}
